// MUI
import {
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  styled,
} from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Components
import { SettingsSection } from '$common/settings-section'
import { BottomDrawer } from '$common/bottom-drawer'
// Icons
import { ContactIcon, ChannelIcon, GroupIcon } from '$common/icons'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'
// Localization
import { t } from '$i18n'
import { openContacts, openCreateHall } from '$logic/router'

const StyledMenuItem = styled(MenuItem)`
  min-height: 44px;
  height: 44px;

  padding: 8px 25px 8px 20px;
  box-sizing: border-box;
`

const IntendedDivider = styled(Divider)`
  &.MuiDivider-inset {
    margin-right: 20px;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  color: ${({ theme }) => theme.palette.secondary700};
`

interface CustomMenuItemProps {
  text: string
  icon: JSX.Element
  onClick: () => unknown
}

function CustomMenuItem({
  text,
  icon,
  onClick,
  ...props
}: CustomMenuItemProps) {
  return (
    <StyledMenuItem onClick={onClick} {...props}>
      <StyledListItemIcon>{icon}</StyledListItemIcon>
      <ListItemText
        primaryTypographyProps={{ variant: 'subtitle3', color: 'neutral900' }}
      >
        {text}
      </ListItemText>
      <ArrowIOSIcon />
    </StyledMenuItem>
  )
}

export function NewChatModal({ isOpen }: { isOpen: boolean }) {
  const onCreateChannel = async () => {
    await closeCurrentModal()
    await openCreateHall('CHANNEL')
  }

  const onCreateGroup = async () => {
    analite('CREATE_GROUP')
    await closeCurrentModal()
    await openCreateHall('GROUP')
  }

  const onContacts = async () => {
    await closeCurrentModal()
    await openContacts()
  }

  return (
    <BottomDrawer
      onClose={closeCurrentModal}
      isOpen={isOpen}
      bottomSafeAreaColor="veryLightGray"
    >
      <Box sx={{ bgcolor: 'veryLightGray' }}>
        <SettingsSection
          headerText={t('newChatModal.newChat')}
          headerColor="neutral1000"
          headerVariant="h3"
        >
          <Box sx={{ padding: '3px 0' }}>
            <CustomMenuItem
              text={t('newChatModal.createGroup')}
              icon={<GroupIcon />}
              onClick={onCreateGroup}
            />

            <IntendedDivider variant="inset" />

            <CustomMenuItem
              text={t('newChatModal.createChannel')}
              icon={<ChannelIcon />}
              onClick={onCreateChannel}
            />
          </Box>
        </SettingsSection>

        <SettingsSection>
          <Box sx={{ padding: '3px 0' }}>
            <CustomMenuItem
              text={t('newChatModal.myContacts')}
              icon={<ContactIcon />}
              onClick={onContacts}
            />
          </Box>
        </SettingsSection>
      </Box>
    </BottomDrawer>
  )
}
